
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addSystem, upSystem } from "@/api/api-basic";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAddMenu extends Vue {
  @Prop({ default: "" }) private subSystemId!: string;
  private modalShow = false;
  private title = i18n.t("menuList.addChild");
  private formInline: objAny = {
    menuIcon: "",
    moduleName: "",
    sort: "",
    url: "",
    englishName: "",
    thailandName: "",
    activeMenu: "",
    hidden: 0,
    alwaysShow: 1,
    cacheName: "",
    component: ""
  };
  // private menuTypeList: object[] = [
  //   { label: "菜单", value: "1" },
  //   { label: "按钮", value: "2" }
  // ];

  private itemData: objAny = {};
  private formObj: objAny = {};
  private ruleInline: objAny = {
    moduleName: [
      {
        required: true,
        message: i18n.t("menuList.moduleNamePl"),
        trigger: "blur"
      }
    ],
    englishName: [
      {
        required: true,
        message: i18n.t("menuList.englishNamePl"),
        trigger: "blur"
      }
    ],
    thailandName: [
      {
        required: true,
        message: i18n.t("menuList.thailandNamePl"),
        trigger: "blur"
      }
    ],
    url: [
      { required: true, message: i18n.t("menuList.urlPl"), trigger: "blur" }
    ],
    sort: [{ required: true, validator: regular.int, trigger: "blur" }],
    cacheName: [
      {
        required: true,
        message: i18n.t("menuList.cacheNamePl"),
        trigger: "blur"
      }
    ],
    component: [
      {
        required: true,
        message: i18n.t("menuList.componentPl"),
        trigger: "blur"
      }
    ]
  };

  private modalType = "add";

  public open(type: string, item?: objAny) {
    console.log(item);
    this.modalShow = true;
    this.formInline.menuIcon = "";
    this.formInline.moduleName = "";
    this.formInline.sort = "";
    this.formInline.url = "";
    this.formInline.englishName = "";
    this.formInline.thailandName = "";
    this.formInline.hidden = 0;
    this.formInline.alwaysShow = 1;
    this.formInline.cacheName = "";
    this.formInline.component = "";
    this.modalType = type;
    if (item) {
      this.itemData = item;
      this.title =
        type == "add" ? i18n.t("menuList.addChild") : i18n.t("menuList.updata");
      if (type == "add") {
        this.formInline.menuIcon = "";
      } else {
        this.formInline.menuIcon = item.icon;
        this.formInline.moduleName = item.moduleName;
        this.formInline.sort = item.sort;
        this.formInline.url = item.url;
        this.formInline.englishName = item.englishName;
        this.formInline.thailandName = item.thailandName;
        this.formInline.hidden = item.hidden;
        this.formInline.alwaysShow = item.alwaysShow;
        this.formInline.cacheName = item.cacheName;
        this.formInline.component = item.component;
      }
    } else {
      this.title = i18n.t("menuList.add");
      this.itemData = {
        level: 0,
        modulePkId: 0
      };
    }
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    let ret;
    if (this.modalType == "add") {
      const data = Object.assign(this.formInline, {
        level: this.itemData.level + 1,
        subSystemId: this.subSystemId,
        parentId: this.itemData.modulePkId
      });
      ret = await addSystem(data);
    } else {
      const data = Object.assign(this.formInline, {
        modulePkId: this.itemData.modulePkId
      });
      ret = await upSystem(data);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
  }
  public handleReset() {
    this.formObj.resetFields();
  }

  mounted() {
    this.formObj = this.$refs["formValidate"];
  }
}
